import React from "react";
import { Link } from "react-router-dom";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

const roles = [
  { title: "Founding Engineer (Full-stack)", location: "Remote · EU/US", team: "Engineering" },
  { title: "ML Engineer — Reply Agent", location: "Remote · EU/US", team: "AI" },
  { title: "Product Designer", location: "Remote · EU", team: "Design" },
  { title: "Founding GTM (SDR / AE hybrid)", location: "Remote · US", team: "Go-to-market" },
];

export default function Careers() {
  return (
    <MarketingPage
      seo={{
        title: "Careers — Build the future of human-in-the-loop AI outreach",
        description:
          "Join Collavue. We're hiring engineers, designers, and GTM operators to build the AI lead discovery and reply layer for B2B teams.",
        path: "/careers",
        keywords: "Collavue careers, AI startup jobs, remote SaaS jobs, AI engineering jobs",
      }}
    >
      <PageHero
        eyebrow="Careers"
        title="Build the future of"
        italicWord="AI-assisted GTM."
        description="We're a small, opinionated team building tools we'd want to use ourselves. Remote-first. Async-first. Bias toward shipping."
      />
      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-5xl mx-auto px-6 py-20">
          <h2 className="font-display text-3xl text-[#0a1736] font-semibold">Open roles</h2>
          <div className="mt-6 grid gap-3">
            {roles.map((r) => (
              <Link
                key={r.title}
                to="/about"
                className="rounded-xl border border-[#e3dccb] bg-[#faf6ee]/40 p-5 flex items-center justify-between hover:border-[#2d5bff] transition-colors"
              >
                <div>
                  <div className="font-display text-lg text-[#0a1736] font-semibold">{r.title}</div>
                  <div className="text-sm text-[#5a6478] mt-1">{r.team} · {r.location}</div>
                </div>
                <span className="text-[#2d5bff] text-sm">Apply →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </MarketingPage>
  );
}
